(function($) {

    $(document).on('click', 'a[href^="#"]', function (event) {
        event.preventDefault();

        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top - 100
        }, 900);
    });

    $(document).ready(function () {
        $('.podcast-button').addClass('show');
    });

    $('.podcast-button__close').click(function (e) {
        e.preventDefault();
        $('.podcast-button').removeClass('show');
    });

})( jQuery );